import { MemberService } from './member.service';
// src/app/auth/auth.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { JwtHelper } from 'angular2-jwt';
import * as auth0 from 'auth0-js';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AuthService {
  DEBUG:boolean = false;

  
  
  membersRusUser: any = {};
  // this.observableAuth
  redirecturl:string = "";
  
 
  // redirecturl:string =  'http://localhost:5000/home';
  // redirecturl:string = 'https://www.wringers-bertem.be/home';

  
  auth0: auth0.WebAuth;
  

  profile: any;
  private roles: string[] = [];
  observableAuth: BehaviorSubject<any>;

  constructor(public router: Router, private memberService: MemberService) {
    
    if (this.DEBUG){
      this.redirecturl =  'http://localhost:5000/home';
  
    }else{
      this.redirecturl = 'https://www.wringers-bertem.be/home';
    }

    this.auth0 = new auth0.WebAuth({
      clientID: 'G2xXH3vel20s71ndCxNRPak6hhNE2rtG',
      domain: 'membersrus.eu.auth0.com',
      responseType: 'token id_token',
      audience: 'https://api.membersrus.com',
      redirectUri: this.redirecturl,
      // redirectUri: 'https://www.wringers-bertem.be/home',
      // redirectUri: 'http://staging.millexoft.be/home',
      scope: 'openid email profile'
    });


    this.profile = JSON.parse(localStorage.getItem('profile') || '{}');
    this.readRolesFromLocalStorage();
    this.observableAuth = new BehaviorSubject(this.membersRusUser);
  }

  public isInRole(roleName: string) {
    // console.log("rolename: "+roleName);
    // console.log("this.roles: "+this.roles);
    this.readRolesFromLocalStorage();
    
    
    if (this.DEBUG){
      // DEBUG to swap to different profile.
      // this.roles = ['baankapitein']
    }

    return this.roles.indexOf(roleName) > -1;
  }

  // public isInRoles(roles: string[]): boolean {
  //   console.log("In auth Service: "+this.roles + " roles needed to be checked: "+roles);
  //   if (!roles) return true;
  //   console.log(roles.every(r => this.roles.indexOf(r)>=0));
  //   return this.roles && roles.every(r => this.roles.indexOf(r) >= 0);
  // }



  public login(): void {
    this.auth0.authorize();
  }

  private readRolesFromLocalStorage() {
    var token = localStorage.getItem('token');
    if (token) {
      var jwtHelper = new JwtHelper();
      const decodedToken = jwtHelper.decodeToken(token);
      var tokenExpired = jwtHelper.isTokenExpired(token);
      if (decodedToken.hasOwnProperty('https://membersRus.com/roles') && !tokenExpired) {
        this.roles = decodedToken['https://membersRus.com/roles'];
      }
    }
  }

  public getMembersRusUser(id: string) {
    // console.log("this.getMembersRusUser "+id)
    if (id) {
      this.memberService.getMemberByAuthId(id).subscribe(d => {
        this.membersRusUser = d;
        this.observableAuth.next(this.membersRusUser );
      },
        error => {
          // console.log(error);
          this.membersRusUser = {};
        });
    }
  }


  public handleAuthentication(): void {
    this.auth0.parseHash((err, authResult) => {
      // console.log(authResult)
      if (authResult && authResult.accessToken && authResult.idToken) {
        // console.log(authResult);
        window.location.hash = '';
        this.setSession(authResult);
        // console.log(authResult);
        this.auth0.client.userInfo(authResult.accessToken, (error, profile) => {
          if (error)
            throw error;
          localStorage.setItem('profile', JSON.stringify(profile));
          this.profile = profile;
          this.getMembersRusUser(this.profile.sub);
        });

        this.readRolesFromLocalStorage();

        this.router.navigate(['/home']);
      } else if (err) {
        this.router.navigate(['/home']);
        console.log(err);
      }
    });
    this.getMembersRusUser(this.profile.sub);
  }

  private setSession(authResult: any): void {
    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
  }

  public logout(): void {
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('profile');
    localStorage.removeItem('expires_at');
    this.roles = [];
    this.profile = [];
    // Go back to the home route
    this.router.navigate(['/']);
  }

  public isAuthenticated(): boolean {
    // Check whether the current time is past the
    // Access Token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at') || '{}');
    return new Date().getTime() < expiresAt;
  }

  public ifNotAuthenticatedRouteToHome(){
    if (!this.isAuthenticated()){
      this.router.navigate(['/']);
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/auth.service.ts